import { SxProps } from "@mui/material";

export type Direction = "row" | "column" | "row-reverse" | "column-reverse";

export const getFlexStyles = (direction: Direction = "row", grow: boolean = false): React.CSSProperties => ({
    display: "flex",
    flexDirection: direction,
    ...(grow ? { flexGrow: 1 } : {}),
})

export const getFluidBoxStyles = (): React.CSSProperties => {
    return {
        width: "100%",
        height: "100%",
    };
}

export const getAbsoluteFluidBoxStyles = (): React.CSSProperties => {
    return {
        position: "absolute",
        ...getFluidBoxStyles(),
        top: 0,
        left: 0,
    }
}

export const getScreenFluidBoxStyles = (): React.CSSProperties => {
    return {
        width: "100dvw",
        height: "100dvh",
    };
}

export const getCenterStyles = (direction: Direction = "row"): React.CSSProperties => {
    return {
        ...getFlexStyles(direction),
        justifyContent: "center",
        alignItems: "center",
    };
}

export const getXCenterStyles = (direction: Direction = "row"): React.CSSProperties => {
    return {
        ...getFlexStyles(direction),
        [direction === "row" ? "justifyContent" : "alignItems"]: "center",
    };
}

export const getYCenterStyles = (direction: Direction = "row"): React.CSSProperties => {
    return {
        ...getFlexStyles(direction),
        [direction === "row" ? "alignItems" : "justifyContent"]: "center",
    };
}

export const getCenteredSpaceBetweenStyles = (): React.CSSProperties => {
    return {
        ...getYCenterStyles(),
        justifyContent: "space-between",
        width: "100%",
    }
}

export const getSizeStyles = (size: string | number): React.CSSProperties => {
    return {
        width: size,
        height: size,
    };
}

export const stretchHorizontallyParentAndChildren = (): SxProps => ({
    width: "100%",
    "> *": { width: "100%" }
});

export const softHide = (hidden: boolean): SxProps => ({
    opacity: hidden ? 0 : 1,
    transition: "opacity 0.3s ease-in-out",
    pointerEvents: hidden ? "none" : "auto",
});